// The batchNo segments used by getUnknownBatchID / getTBDBatchID. These never
// represent a real physical batch, so callers matching on batchNo need to
// recognise and exclude them.
const PLACEHOLDER_BATCH_NOS = ['UNKNOWN', 'TBD']

module.exports = {
  getUnknownBatchID,
  getTBDBatchID,
  PLACEHOLDER_BATCH_NOS
}

function getUnknownBatchID (productId) {
  return `${productId}:manufacturer:unknown:batchNo:UNKNOWN`
}

function getTBDBatchID (productId) {
  return `${productId}:manufacturer:tbd:batchNo:TBD`
}
